import { render, staticRenderFns } from "./SidePanelStaff.vue?vue&type=template&id=334fa30a"
import script from "./SidePanelStaff.vue?vue&type=script&lang=js"
export * from "./SidePanelStaff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports